module.exports = __webpack_public_path__ + "assets/img/carousel-4-640.e628b85f.webp";